import React from 'react'

const index = () => {
  let frameStyle={
    width: '100%',
    marginBottom: '3rem',
    border: '0',
    transform: 'scale(1)',
    overflow: 'hidden'
  }
  return (
    <div className="component-desc">
        <h2 className="heading">Introduction</h2>
        <div className="description">
          Foam UI is a free to use component library, which helps developers
          to use styles and components, by using pre-defined class names. It is
          designed so that one can easily build up their project functionality
          without having to worry about the design and style .
        </div>
        <div className="divider"></div>
        <h3 className="heading">Installation</h3>
        <div className="description">
          Copy this and put it in your head tag in yout HTML file.
        </div>
        <div className="carbon-container">
        <iframe
            src="https://carbon.now.sh/embed?bg=rgba%28171%2C184%2C195%2C0%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Clink%2520rel%253D%2522stylesheet%2522%2520href%253D%2522https%253A%252F%252Ffoam-ui.netlify.app%252Fcomponents%252Fcomponents.css%2522%253E"
            style={frameStyle}
            sandbox="allow-scripts allow-same-origin"
          >
          </iframe>
        </div>
        
    </div>
  )
}

export default index